import { useSelector } from 'react-redux';
import { getPricingContentNotificationsViewed } from 'resources/PriceBook/Data';
import { AmplitudeFlagKeys } from 'types/amplitudeFlags';

import useIsExperimentActive from 'components/Amplitude/useIsExperimentActive';
import { LocalStorage } from 'components/Common/Utils/local_storage';
import { PricebookBadgeData } from 'components/Toolbar/ToolbarPropsTypes';

const usePricebookBadgeValue = ({ pricebookBadgeData }: { pricebookBadgeData?: PricebookBadgeData }) => {
  const canUserSeeLatestQuarterUpdate = useIsExperimentActive(AmplitudeFlagKeys.profitRhinoContentUpdates);
  const viewedPricingContentUpdateFromStorage = pricebookBadgeData?.update_name
    ? (JSON.parse(LocalStorage.getItem('pricebookNotificationsViewed')) || {})[pricebookBadgeData.update_name]
    : undefined;
  const viewedPricingContentUpdateFromRedux = useSelector(getPricingContentNotificationsViewed)?.versions;
  const viewedPricingContentUpdate = viewedPricingContentUpdateFromStorage || viewedPricingContentUpdateFromRedux;
  const showPricebookBadge =
    pricebookBadgeData?.update_available && !viewedPricingContentUpdate && canUserSeeLatestQuarterUpdate;

  const badgeValue = showPricebookBadge ? 1 : 0;

  return { badgeValue };
};

export default usePricebookBadgeValue;
